// Copyright (c) 2026 Riddle, LLC. All rights reserved.
// Author: Ray Harris

export const DEMO_WORKSPACE_TENANT_PREFIX = "t-demo";

export function isDemoWorkspaceTenant(tenantId: string | undefined): boolean {
  return (
    tenantId !== undefined &&
    tenantId.toLowerCase().startsWith(DEMO_WORKSPACE_TENANT_PREFIX)
  );
}

export interface DemoWorkspaceSignals {
  tenantId: string | undefined;
  isTestOrPreview: boolean;
  isAuthConfigured: boolean;
  allowMissingAuthDemo: boolean;
}

export function isDemoWorkspace(signals: DemoWorkspaceSignals): boolean {
  if (signals.isTestOrPreview) {
    return true;
  }

  if (!signals.isAuthConfigured) {
    return signals.allowMissingAuthDemo;
  }

  return isDemoWorkspaceTenant(signals.tenantId);
}
